const healthStatusBtn = ({ displayName, imgURL, imgURL2, heathBtnId  }) => `
        <button data-value="${heathBtnId}" data-type="${displayName}" data-btn="health-status" data-target="" class="btn btn-dusk-outline btn-selecter btn-selecter--left">
            <img class="off-hover-icon js-confirm-img" alt="${displayName}" src="${imgURL}">
            <img class="on-hover-icon" alt="${displayName}" src="${imgURL2}">
            ${displayName}
        </button>
`;


const petType = ({ displayName, imgURL, imgURL2, speciesId, isMember, name  }) => `
        <button data-value="${speciesId}" data-type="${name}" data-member="${isMember}" class="btn btn-dusk-outline btn-selecter btn-selecter--left js-show-step js-btn-selecter">
            <img class="off-hover-icon js-confirm-img" alt="${displayName}" src="${imgURL}">
            <img class="on-hover-icon" alt="${displayName}" src="${imgURL2}">
            ${displayName}
        </button>
`;

const otherPetType = ({ displayName, speciesId  }) => `
    <li data-value="${speciesId}" role="option" class=""><a href="#" class="js-other-pet-selecter" data-value="${speciesId}" data-type="${displayName}" data-filter="${displayName}">${displayName}</a></li>
`;

const existPet = ({ displayName, imgURL, petId, careClub, species, genderId  }) => `
     <button data-pet-id="${petId}" data-pet-name="${displayName}" data-species="${species}" data-careclub="${careClub}" data-genderid="${genderId}" class="btn btn-dusk-outline btn-selecter btn-selecter--thumb btn-selecter--left js-acitve-btn">
        <div class="btn-selecter--thumb__icon">
            <img data-object-fit="cover" class="js-confirm-img" alt="${displayName}" src="${imgURL}">
        </div>
            ${displayName}
        </button>
`;


const petInputGroup = ({ displayName }) => `
    <div class="form-label-group">
        <div class="form-check custom-radio">
            <input class="form-check-input custom-control-input" type="radio" name="petName" id="${displayName}" value="${displayName}">
            <label class="form-check-label" for="${displayName}">
            ${displayName}
            </label>
        </div>
    </div>
`;

const breedsOptions = ({  displayName, Id, speciesId }) => `
    <option value="${displayName}" data-id="${Id}" data-speciesId="${speciesId}" >${displayName}</option>
`;

const serviceBtn = ({ displayName, imgURL, serviceId, ind }) => `
    <li>
        <button class="ccde__services__list__item js-service-option" data-service-id="${serviceId}" data-option="${ind}">
            <img src="${imgURL}" />
            <span>${displayName}</span>
        </button>
    </li>
`;

const serviceDesc = ({ displayName, desc, ind }) => `
    <li class="ccde__services__list__desc__item js-service-desc" style="display: none;" data-desc="${ind}">
        <strong>${displayName}</strong>
        <span>${desc}</span>
    </li>
`;


const hospitalItem = ({ name, id, index }) => `
    <div class="ccde__select-hospital__hospital-list__item form-check custom-radio">
        <input data-hospital-id="${id}" data-name="${name}" name="hospital-result" id="${id}" value="${id}" class="form-check-input custom-control-input js-hospital-item" type="radio">
        <label class="form-check-label" for="${id}">
        ${name}
        </label>
    </div>
`;


export {
    healthStatusBtn,
    petType,
    otherPetType,
    existPet,
    petInputGroup,
    breedsOptions,
    serviceDesc,
    serviceBtn,
    hospitalItem
};
